import FormError from './form-error.model';
import { BITCOIN_DECIMAL_PLACES_FORMAT, format} from '@shared/utils/number.utils';

import numeral from 'numeral';
import { DEFAULT_DECIMAL_FORMAT } from '../../../../../shared/utils/number.utils';

export class SubTransaction {
  constructor(key) {
    this.key = key;

    this.product = null;
    this.amount = 0;
    this.btc = 0;
    this.chargeFee = true;

    this.customerProducts = [];
  }

  convertBtcToAmount(btcAdjustedRate) {
    let converted = numeral(btcAdjustedRate * this.btc);
    this.amount = format(converted, DEFAULT_DECIMAL_FORMAT);
  }

  convertAmountToBtc(btcAdjustedRate) {
    let converted = numeral(this.amount / btcAdjustedRate);
    this.btc = format(converted, BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  get formattedBtc() {
    return format(numeral(this.btc), BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  get formattedAmount() {
    return format(numeral(this.amount), BITCOIN_DECIMAL_PLACES_FORMAT);
  }

  get forFee() {
    return this.chargeFee ? 1 : 0;
  }
}

export class TransactionForm {
  constructor(customerProducts, paymentOptions) {
    // Form Fields
    this.email = null;
    this.amount = null;
    this.paymentOption = null;
    this.transactionPassword = null;
    this.subTransactions = [];

    // Collections needed to create the form
    this.customerProducts = customerProducts;
    this.paymentOptions = paymentOptions;
    this.selectedCustomerProducts = [];

    // Miscellaneous
    this.error = new FormError();
    this.nextItemKey = 0;
    this.freeFee = false; // This becomes true when the customer comes from France coz we loved France so much.
    this.isUsingGoogleTwoFactor = false;

    this.props = {
      isSubmitting: false,
      isReady: false,
      readOnly: false
    }

    this.isBank = false;
    this.bankErrorMessage = '';
    this.addSubTransaction();
  }

  addSubTransaction() {
    let subTransaction = new SubTransaction(this.nextItemKey);
    let shallowCopy = this.customerProducts.slice(0); //copy by value not reference.

    shallowCopy = shallowCopy.filter(item => !this.selectedCustomerProducts.includes(item.id));
    subTransaction.customerProducts = shallowCopy;

    if (this.nextItemKey !== 0) {
      subTransaction.chargeFee = false;
    }

    if (this.customerProducts.length === 1) {
      subTransaction.product = this.customerProducts[0].id;
    }

    this.subTransactions.push(subTransaction);
    this.nextItemKey++;
  }

  removeSubTransaction(subTransaction, index) {
    this.removeFromSelectedProducts(subTransaction.product);
    this.reloadToAllCustomerProducts(subTransaction.product, index);

    for (let i = 0; i < this.subTransactions.length; i++) {
      if (this.subTransactions[i].key === subTransaction.key) {
        this.subTransactions.splice(i, 1);
        break;
      }
    }
  }

  chargeFeeSelected(subTransaction) {
    for (let i = 0; i < this.subTransactions.length; i++) {
      if (this.subTransactions[i].key !== subTransaction.key) {
        this.subTransactions[i].chargeFee = false;
      } else {
        this.subTransactions[i].chargeFee = true;
      }

      let fees = document.querySelectorAll('input[type=checkbox]');
      let unchecked = [].filter.call( fees, function( fee ) {
        return !fee.checked;
      });

      if (fees.length == unchecked.length) {
        $('#invalidAction').modal('show');
      }
    }
  }

  get totalAmount() {
    let totalAmount = 0;

    angular.forEach(this.subTransactions, (subTransaction) => {
      totalAmount += Number(subTransaction.amount);
    });

    return totalAmount;
  }

  get totalAmountToBeWithdrawn() {
    return this.totalAmount - this.fee;
  }

  get fee() {
    if (this.feeFree) {
      return 0;
    }

    let actualFee = this.totalAmount * Number(this.feeMultiplier);

    return actualFee;
  }

  get isValid() {
    return this.subTransactions.length > 0;
  }

  get canAddProduct() {
    return this.customerProducts.length > 1;
  }

  get isReadOnly() {
    return this.props.readOnly;
  }

  reset() {
    this.amount = null;

    this.error = new FormError();
    this.nextItemKey = 0;

    // TODO: Should we reset this also?
    this.props.readOnly = false;
    this.props.isSubmitting = false;
    this.props.isReady = false;

    this.subTransactions = [];
    this.selectedCustomerProducts = [];

    this.addSubTransaction();
  }

  clearError() {
    this.error = new FormError();
  }

  toPayload() {
    let payload = {
      transaction: {
        transactionPassword: this.transactionPassword,
        usingGoogleAuthPassword: this.isUsingGoogleTwoFactor,
      }
    };

    payload['transaction']['paymentOption'] = this.paymentOption;
    payload['transaction']['paymentOptionType'] = this.paymentOptionType;
    payload['transaction']['customerFee'] = this.fee;

    if (this.paymentOptionType == 'BANK') {
      payload['transaction']['bankDetails'] = this.getBankDetails();
    }

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
      subTransactions[subTransaction.key] = {
        product: subTransaction.product,
        amount: subTransaction.amount,
        forFee: subTransaction.forFee
      };
    }

    payload['transaction']['subTransactions'] = subTransactions;

    return payload;
  }

  authenticationSwitched(isUsingGoogleTwoFactor) {
    this.isUsingGoogleTwoFactor = isUsingGoogleTwoFactor;
  }

  //============================================================================
  //  Code Below handles operations when a change in product selection occurs.
  //============================================================================
  onChangedCustomerProduct(index, newValue, oldValue) {
    this.selectedCustomerProducts.push(newValue);
    this.removeFromSelectedProducts(oldValue);
    this.removeFromSelection(newValue, index);
    this.reloadToAllCustomerProducts(oldValue, index);
  }

  removeFromSelection(newValue, index) {
    // Remove CustomerProduct with id matching the newValue within each SubTransactions
    for (let [sIndex, subTransaction] of this.subTransactions.entries()) {
      // This condition will not remove the CustomerProduct from the owning SubTransaction.
      // The reason is that, when we tried to remove it, the ng-model will be affected does
      // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
      if (index !== sIndex) {
        for (let [cIndex, customerProduct] of this.subTransactions[sIndex].customerProducts.entries()) {
          if (customerProduct.id === newValue) {
            this.subTransactions[sIndex].customerProducts.splice(cIndex, 1);
          }
        }
      }
    }
  }

  removeFromSelectedProducts(value) {
    if (value) {
      let oldValueIndex = this.selectedCustomerProducts.indexOf(value);
      this.selectedCustomerProducts.splice(oldValueIndex, 1);
    }
  }

  // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
  reloadToAllCustomerProducts(oldValue, index) {
    if (oldValue) {
      let oldCustomerProduct = this.getCustomerProductById(oldValue);
      for (let [sIndex, subTransaction] of this.subTransactions.entries()) {
        if (index !== sIndex) {
          subTransaction.customerProducts.push(oldCustomerProduct);
        }
      }
    }
  }

  getCustomerProductById(id) {
    return this.customerProducts.filter(customerProduct => customerProduct.id === id)[0];
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/transactionform.model.js